export const removingSpaces = (stringWithSpaces: string): string => {
    return stringWithSpaces.replace(/\s/g, '');
};